export const DEFAULT_LAMBDA_ARN_CONFIG = [
  {
    environment: 'dev',
    arn: 'arn:aws:lambda:us-east-1:330801203043:function:qs-refresh',
  },
  {
    environment: 'beta',
    arn: 'arn:aws:lambda:us-east-1:330801203043:function:qs-refresh',
  },
  {
    environment: 'prod',
    arn: 'arn:aws:lambda:us-east-1:359182851103:function:qs-refresh',
  },
];

export const AWS_CRON_DOCS_URL = 'https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-scheduled-rule-pattern.html';

export const TARGET_TYPE_OPTIONS = [
  { label: 'Lambda', value: 'LAMBDA' },
  { label: 'Glue', value: 'GLUE' }
];